<template>
  <v-container fluid>
    <PageHeaderSlot>
      <template slot="top-right-slot" v-if="canCreate">
        <FormButton text="createMonthPass" isAdd class="ml-2" :to="{ name: 'CreateMonthPass' }" />
      </template>
    </PageHeaderSlot>

    <Datatable
      :isLoading="tableLoading"
      :tableHeaders="tableHeaders"
      :tableData="tableData"
      :page.sync="tableFilter.page"
      :pageLimit.sync="tableFilter.limit"
      :itemTotal="tableItemTotal"
      @options-update="getMonthPassData()"
      actionViewRouteLink="MonthPassDetails"
    >
      <template v-slot:[`item.type`]="{ item }">
        {{ $t(`monthPassTypeOption.${item.type}`) }}
      </template>
    </Datatable>
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'

export default {
  name: 'MonthPassList',
  components: {
    Datatable,
  },
  computed: {
    tableHeaders() {
      const vm = this
      let headers = [
        { value: 'name', text: vm.$t('monthPassName') },
        { value: 'type', text: vm.$t('monthPassType') },
        { value: 'total', text: vm.$t('price') },
      ]

      if (this.$validate.allowAction('MonthPassDetails', this.userType)) {
        headers.push({ value: 'actionView', text: '', align: 'end' })
      }
      return headers
    },
    // permission & setting
    canCreate() {
      return this.$validate.allowAction('CreateMonthPass', this.userType)
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    tableLoading: false,
    tableData: [],
    tableItemTotal: 0,
    tableFilter: {
      page: 1,
      limit: 10,
    },
  }),
  methods: {
    async getMonthPassData(regenUrl = true) {
      if (regenUrl === true) {
        this._regenerateURL()
      }
      this.tableLoading = true
      try {
        let payload = {
          filter_limit: this.tableFilter.limit,
          filter_page: this.tableFilter.page - 1,
        }
        const selectedSchool = this.gfGetUserSelectedSchool()
        if (selectedSchool > -1) {
          payload['center_id'] = selectedSchool
        }

        const { data, total } = await this.$Fetcher.GetMonthPasses(payload)
        this.tableData = data.map(el => {
          return {
            ...el,
            total: el.price,
          }
        })
        this.tableItemTotal = total
      } catch (err) {
        this.$common.error(err)
        this.tableData = []
        if (this.tableFilter.page === 1) {
          this.tableItemTotal = 0
        }
      } finally {
        this.tableLoading = false
      }
    },

    _getQuery() {
      this.tableFilter.page = 1
      this.tableFilter.limit = 10
      const query = this.gfGetTableQuery({
        page: 'int',
        limit: 'int',
      })
      for (const key in this.tableFilter) {
        if (this.$validate.DataValid(query[key])) {
          this.$set(this.tableFilter, key, query[key])
        }
      }
    },
    _regenerateURL() {
      let q = {
        page: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.page : null,
        limit: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.limit : null,
      }
      const newQuery = this.$common.diffQuery(q, this.$route.query)
      if (newQuery) this.$router.replace({ query: newQuery })
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: MonthPassList')
      this.userType = this.gfGetUserType()
      this._getQuery()
      this.$store.dispatch('toggleLoadingPage', false)

      await this.getMonthPassData(false)
    },
  },

  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.tableLoading = true
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    this.$XHR.abort()
    next()
  },
}
</script>
